import React from "react";
import { useNavigate } from "react-router-dom";
import { Pagination } from "antd";
import formatError from "../../../../services/FormatError";
import { updateNotificationStatus } from "../../../../services/NotificationsService";

function timeAgo(dateString) {
  const createdDate = new Date(dateString);
  const now = new Date();
  const timeDifference = now - createdDate;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  if (weeks < 4) return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
  if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
  return `${years} year${years === 1 ? "" : "s"} ago`;
}

const Notes = ({
  toggleTab,
  PerfectScrollbar,
  toggle,
  seen,
  tableParams,
  setTableParams,
  notificationsData,
  getNotifications,
}) => {
  const navigate = useNavigate();

  const onChangePagination = (page, pageSize) => {
    setTableParams((prevState) => ({
      ...prevState,
      current: page,
      pageSize: pageSize,
    }));
  };

  const onSeen = (id) => {
    updateNotificationStatus(id)
      .then((res) => {
        getNotifications();
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  return (
    <div
      className={`tab-pane fade  ${
        toggleTab === "NEW" || toggleTab === "SEEN" ? "active show" : ""
      }`}
      id="notes"
    >
      <div className="card mb-sm-3 mb-md-0 note_card">
        <div className="card-header chat-list-header">
          <div className="w-100">
            <Pagination
              current={tableParams.current}
              pageSize={tableParams.pageSize}
              total={tableParams.total}
              onChange={onChangePagination}
              showSizeChanger={true}
              pageSizeOptions={[10, 20, 30, 40, 50]}
              simple={true}
            />
          </div>
        </div>
        <PerfectScrollbar
          className={`card-body contacts_body p-0 dz-scroll  ${
            toggle ? "ps ps--active-y" : ""
          }`}
          id="DZ_W_Contacts_Body2"
        >
          <ul className="contacts">
            {notificationsData?.length > 0 ? (
              notificationsData.map((item, index) => (
                <li
                  key={`notification${item?.title}${index}`}
                  className={`active ${
                    toggleTab === "SEEN" ? "active-notification-li" : ""
                  }`}
                  // onClick={() => navigate(item?.action?.url)}
                >
                  <div style={{ display: "block" }} className="bd-highlight">
                    <div className="user_info mb-2">
                      <span>{item?.title}</span>
                      <p>{item?.message}</p>
                    </div>
                    <div
                      className={`d-flex ${
                        toggleTab === "NEW"
                          ? "justify-content-between"
                          : "justify-content-end"
                      } align-items-center w-100`}
                    >
                      <bold style={{ color: "#6bb3f7" }}>
                        {timeAgo(item?.createdat)}
                      </bold>
                      {toggleTab === "NEW" && (
                        <bold
                          style={{ color: "#FF4C41" }}
                          onClick={() => onSeen(item?.id)}
                        >
                          Mark as seen
                        </bold>
                      )}
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="active text-center">
                No {seen ? "Seen" : "New"} Notifications
              </li>
            )}
          </ul>
        </PerfectScrollbar>
      </div>
    </div>
  );
};

export default Notes;
